import { useState } from "react";
import type { PetSpecies } from "@/shared/contracts";
import { speciesArtUrl } from "@/shared/ui";

/**
 * 物种类别小图（UI-ASSET-002 v1，r7k 交付：192×192 透明 WebP，指纹见
 * docs/coordination/ui-assets/deliveries/UI-ASSET-002-v1.md；豚鼠、龙猫、刺猬、雪貂是 ASSET-UI-029 v1，同样是 r7k 画的 192×192 透明 WebP，
 * 原字节和指纹见 public/ui-assets/ASSET-UI-029/v1/SOURCE.md，SPECIES-ART-01）。只表示物种类别，不冒充某只宠物的样子：
 * 选物种时用；居民页（ResidentPortrait）和领养来的原创居民（PetPortrait、共享头像 PetAvatar，2026-09-25）没有照片时，
 * 头像位置也放它（地址都来自 shared/ui 的 speciesArtUrl，同一张图），但都说明这是物种插画、不是 TA 本人的照片
 * （读屏；居民页另有“插画”角标）。自己的宠物没照片不用它（爪印）。
 */
export function SpeciesIllustration({ species }: { species: PetSpecies }) {
  // 图打不开（UI-BASE-01b，W-24）：换成 other 那一张，只换一次（换过以后不再接 onError，不会来回循环）。装饰图，换了不影响读屏。
  const [failed, setFailed] = useState<PetSpecies | null>(null);
  const fallen = failed === species;
  return <img className="ps-species-art" src={speciesArtUrl(fallen ? "other" : species)} alt="" aria-hidden="true" width={192} height={192} decoding="async" onError={fallen ? undefined : () => setFailed(species)} />;
}
